import { render } from "./FooterStyleFive.vue?vue&type=template&id=99291064"
import script from "./FooterStyleFive.vue?vue&type=script&lang=js"
export * from "./FooterStyleFive.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__